import { useCallback, useState, useEffect } from 'react';
import { useAssociatedObjectsCardRedesignContext } from '../../../context/AssociatedObjectsCardRedesignContext';
import { Select } from 'foundations-components/transitional/components/Select';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationSortButtons() {
  const {
    sortConfiguration,
    onSortConfigurationChange,
    userPermission,
    propertyDefinitions,
    propertyNames
  } = useAssociatedObjectsCardRedesignContext();
  const firstSort = sortConfiguration === null || sortConfiguration === void 0 ? void 0 : sortConfiguration[0];
  const property = (firstSort === null || firstSort === void 0 ? void 0 : firstSort.property) || 'hs_object_id';
  const order = (firstSort === null || firstSort === void 0 ? void 0 : firstSort.order) || 'DESC';
  const MISSING_SORT_BEHAVIOR = '_last';
  const [sortPropertyOptions, setSortPropertyOptions] = useState([]);
  const handlePropertyChange = useCallback(value => {
    onSortConfigurationChange([{
      property: value.currentTarget.value,
      order,
      missing: MISSING_SORT_BEHAVIOR
    }]);
  }, [onSortConfigurationChange, order]);
  const handleOrderChange = useCallback(value => {
    onSortConfigurationChange([{
      property,
      order: value.currentTarget.value,
      missing: MISSING_SORT_BEHAVIOR
    }]);
  }, [onSortConfigurationChange, property]);
  const getPropertyLabel = useCallback(propertyName => {
    const propertyDef = propertyDefinitions === null || propertyDefinitions === void 0 ? void 0 : propertyDefinitions.find(def => def.property.name === propertyName);
    return (propertyDef === null || propertyDef === void 0 ? void 0 : propertyDef.property.label) || propertyName;
  }, [propertyDefinitions]);

  // Update sortPropertyOptions only when we have valid propertyDefinitions
  useEffect(() => {
    if (propertyDefinitions && propertyDefinitions.length > 0 && propertyNames) {
      const options = propertyNames.map(name => ({
        text: getPropertyLabel(name),
        value: name
      }));
      setSortPropertyOptions(options);
    }
  }, [propertyNames, propertyDefinitions, getPropertyLabel]);
  const sortOrderOptions = [{
    text: I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.ASC'),
    value: 'ASC'
  }, {
    text: I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.DESC'),
    value: 'DESC'
  }];
  const getOrderText = useCallback(() => {
    if (order === 'ASC') {
      return I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.ASC');
    }
    return I18n.text('cardAssociatedObjects.AssociatedObjectsActionBar.DESC');
  }, [order]);
  if (!userPermission) {
    const propertyText = getPropertyLabel(property);
    const orderText = getOrderText();
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "100",
      flexShrink: 0,
      children: [/*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.AssociatedObjectsActionBar.sortedBy"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: propertyText
      }), /*#__PURE__*/_jsx(Text, {
        children: "|"
      }), /*#__PURE__*/_jsx(Text, {
        children: orderText
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(View, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.AssociatedObjectsActionBar.sortBy"
      })
    }), /*#__PURE__*/_jsx(Select, {
      multi: false,
      anchorType: "button",
      buttonUse: "unstyled",
      placement: "bottom",
      value: property,
      searchable: false,
      onChange: handlePropertyChange,
      options: sortPropertyOptions,
      "data-test-id": "sort-property-select"
    }), /*#__PURE__*/_jsx(Select, {
      multi: false,
      anchorType: "button",
      buttonUse: "unstyled",
      placement: "bottom",
      value: order.toString(),
      searchable: false,
      onChange: handleOrderChange,
      options: sortOrderOptions,
      "data-test-id": "sort-order-select"
    })]
  });
}
export default AssociationSortButtons;